const features = [
  {
    icon: 'ri-shield-check-line',
    title: '无需注册',
    desc: '所有综艺内容免费在线观看，打开即看，没有任何门槛和限制。',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '先进的CDN加速技术，高清画质流畅播放，告别缓冲等待的烦恼。',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
  {
    icon: 'ri-4k-line',
    title: '1080P高清',
    desc: '全站综艺内容支持1080P高清画质，给您影院级的观影体验。',
    color: 'text-secondary-600',
    bg: 'bg-secondary-100',
  },
  {
    icon: 'ri-refresh-line',
    title: '极速更新',
    desc: '热门综艺播出后最快2小时内同步上线，让您第一时间看到最新内容。',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    desc: '完美支持电脑、平板和手机，随时随地畅享流畅的偶像综艺。',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么选择爱豆影视观看偶像综艺和真人秀
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5 text-center hover:border-primary-200 transition-all"
            >
              <div className={`w-12 h-12 mx-auto rounded-xl ${item.bg} flex items-center justify-center mb-4`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}